let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fOLlY"), load("2irg6"), load("iLLJH"), load("3kHns"), load("3JzPO"), load("ltXeo")]).then(() => parcelRequire('bbZCI'));